/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import VueRecaptcha from "vue-recaptcha";

require('./bootstrap');

window.Vue = require('vue').default;
import VueRouter from 'vue-router'
import VueProgressBar from 'vue-progressbar'
import Notifications from 'vue-notification'
import GAuth from 'vue-google-oauth2'
import InputTag from 'vue-input-tag'
import VueCookies from 'vue-cookies'

const options = {
    color: '#EC550E',
    failedColor: '#874b4b',
    thickness: '5px',
    transition: {
        speed: '0.2s',
        opacity: '0.6s',
        termination: 300
    },
    autoRevert: true,
    location: 'top',
    inverse: false
}

Vue.use(VueProgressBar, options)
Vue.use(VueRouter)
Vue.use(Notifications)
Vue.use(VueCookies)
Vue.$cookies.config('30d')

const gauthOption = {
    clientId: '186162302800-sc3atqiirmpo98455htkb190nca6aiba.apps.googleusercontent.com',
    scope: 'profile email',
    prompt: 'select_account'
}
Vue.use(GAuth, gauthOption)
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

Vue.component('header-page', require('./components/HeaderPage.vue').default);
Vue.component('header-element', require('./components/HeaderElement.vue').default);
Vue.component('redeem-coin-card', require('./components/Card/RedeemCoinCard.vue').default);
Vue.component('riwayat-card', require('./components/Card/CardRiwayat.vue').default);
Vue.component('post-card', require('./components/Card/CardPost.vue').default);
Vue.component('video-card', require('./components/Card/CardVideo.vue').default);
Vue.component('upload-media', require('./components/UploadMedia.vue').default);
Vue.component('upload-avatar', require('./components/UploadAvatar.vue').default);
Vue.component('form-clean-password', require('./components/Form/CleanPassword.vue').default);
Vue.component('no-content', require('./components/NoContent.vue').default);
Vue.component('no-video', require('./components/NoVideo.vue').default);
Vue.component('loading-block', require('./components/LoadingBlock.vue').default);
Vue.component('search-article', require('./components/SearchArticle.vue').default);
Vue.component('input-tag', InputTag);
Vue.component('pagination', require('laravel-vue-pagination'));
Vue.component('vue-recaptcha', VueRecaptcha);
// Layout
Vue.component('guest-layout', require('./components/Layouts/Guest.vue').default);
Vue.component('auth-layout', require('./components/Layouts/Auth.vue').default);

import App from './components/App';
import Login from './pages/Login';
import Register from './pages/Register';
import RegisterConfirmation from './pages/RegisterConfirmation';
import TermsArticle from './pages/TermsArticle';
import TermsVideo from './pages/TermsVideo';
import LostPassword from './pages/LostPassword';
import LostPasswordConfirmation from "./pages/LostPasswordConfirmation";
import ChangePasswordConfirmation from './pages/ChangePasswordConfirmation';
import ChangeEmailConfirmation from './pages/ChangeEmailConfirmation';
import Logout from './pages/Logout';
import Beranda from './pages/Beranda';
import CreatePost from './pages/post/Create';
import Profile from './pages/Profile';
import Reward from './pages/Reward';

import ProfileEdit from './pages/ProfileEdit';
import ProfileEditPassword from './pages/ProfileEditPassword';
import Verification from './pages/Verification';
import Redeem from './pages/Redeem';
import Voucher from "./pages/Voucher";
import Riwayat from './pages/Riwayat';
import Tentang from './pages/Tentang';
import Kontak from './pages/Kontak';
import PanduanMenulis from './pages/PanduanMenulis';
import PostPublished from './pages/post/Published';
import PostDraft from './pages/post/Draft';
import PostPending from './pages/post/Pending';
import PostRejected from './pages/post/Rejected';
import PostEditing from './pages/post/Editing';
import PostRevision from "./pages/post/Revision";

import EditPost from './pages/post/Edit';

import CreateRecord from './pages/video/Record';
import CreateVideo from './pages/video/Create';
import EditVideo from './pages/video/Edit';
import VideoPublished from './pages/video/Published';
import VideoDraft from './pages/video/Draft';
import VideoPending from './pages/video/Pending';
import VideoRejected from './pages/video/Rejected';
import VideoEditing from './pages/video/Editing';

import ClickmovUpload from './pages/c-upload';

import Popup from './pages/Popup';


import Help from "./pages/help";
import HelpShow from "./pages/help/Show";
import Insight from "./pages/Insight";
import Event from "./pages/Event";

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'login',
            component: Login,
            meta: {
                title: 'Login',
                auth: false
            }
        },
        {
            path: '/register',
            name: 'register',
            component: Register,
            meta: {
                title: 'Register',
                auth: false
            }
        },
        {
            path: '/register/confirmation',
            name: 'register-confirmation',
            component: RegisterConfirmation,
            meta: {
                title: 'Konfirmasi Pendaftaran',
                auth: false,
                force_guest: true
            }
        },
        {
            path: '/terms-article',
            name: 'terms-article',
            component: TermsArticle,
            meta: {
                title: 'Syarat & Ketentuan Artikel',
                auth: false,
                force_guest: true
            }
        },
         {
            path: '/terms-video',
            name: 'terms-video',
            component: TermsVideo,
            meta: {
                title: 'Syarat & Ketentuan Video',
                auth: false,
                force_guest: true
            }
        },
        {
            path: '/lost-password',
            name: 'lost-password',
            component: LostPassword,
            meta: {
                title: 'Lupa Password',
                auth: false
            }
        },
        {
            path: '/lost-password/confirmation',
            name: 'lost-password-confirmation',
            component: LostPasswordConfirmation,
            meta: {
                title: 'Lupa Password',
                auth: false,
                force_guest: true
            }
        },
        {
            path: '/change-password/confirmation',
            name: 'change-password-confirmation',
            component: ChangePasswordConfirmation,
            meta: {
                title: 'Change Password Confirmation',
                auth: false,
                force_guest: true
            }
        },
        {
            path: '/change-email/confirmation',
            name: 'change-email-confirmation',
            component: ChangeEmailConfirmation,
            meta: {
                title: 'Change Email Confirmation',
                auth: false,
                force_guest: true
            }
        },
        {
            path: '/popup',
            name: 'popup',
            component: Popup,
            meta: {
                title: 'Login Popup',
                auth: false,
                force_guest: true
            }
        },
       
        {
            path: '/c-upload',
            name: 'c-upload',
            component: ClickmovUpload,
            meta: {
                title: 'Clickmov Upload',
                auth: false,
                force_guest: true
            }
        },
        {
            path: '/logout',
            name: 'logout',
            component: Logout,
            meta: {
                title: 'Logout',
                auth: true
            }
        },
        {
            path: '/home',
            name: 'home',
            component: Beranda,
            meta: {
                title: 'Beranda',
                auth: true
            }
        },
        {
            path: '/profile',
            name: 'profile',
            component: Profile,
            meta: {
                title: 'Data Diri',
                auth: true
            }
        },
        {
            path: '/profile/edit',
            name: 'profile-edit',
            component: ProfileEdit,
            meta: {
                title: 'Edit Data Diri',
                auth: true
            }
        },
        {
            path: '/profile/edit/password',
            name: 'profile-edit-password',
            component: ProfileEditPassword,
            meta: {
                title: 'Edit Password',
                auth: true
            }
        },
        {
            path: '/verification',
            name: 'verification',
            component: Verification,
            meta: {
                title: 'Verifikasi',
                auth: true
            }
        },
        {
            path: '/redeem',
            name: 'redeem',
            component: Redeem,
            meta: {
                title: 'Redeem',
                auth: true
            }
        },
        {
            path: '/voucher',
            name: 'voucher',
            component: Voucher,
            meta: {
                auth: true
            }
        },
        {
            path: '/history',
            name: 'history',
            component: Riwayat,
            meta: {
                title: 'Riwayat',
                auth: true
            }
        },
        {
            path: '/about',
            name: 'about',
            component: Tentang,
            meta: {
                title: 'Tentang',
                auth: true
            }
        },
        {
            path: '/contact',
            name: 'contact',
            component: Kontak,
            meta: {
                title: 'Kontak',
                auth: true
            }
        },
        {
            path: '/insight',
            name: 'insight',
            component: Insight,
            meta: {
                title: 'Insight',
                auth: true
            }
        },
         {
            path: '/event',
            name: 'event',
            component: Event,
            meta: {
                title: 'Event',
                auth: true
            }
        },
        {
            path: '/reward',
            name: 'reward',
            component: Reward,
            meta: {
                title: 'Reward',
                auth: true
            }
        },
        {
            path: '/writing-guide',
            name: 'writing-guide',
            component: PanduanMenulis,
            meta: {
                title: 'Panduan Menulis',
                auth: true
            }
        },
        {
            path: '/post/published',
            name: 'post-published',
            component: PostPublished,
            meta: {
                auth: true
            }
        },
        {
            path: '/post/draft',
            name: 'post-draft',
            component: PostDraft,
            meta: {
                auth: true
            }
        },
        {
            path: '/post/pending',
            name: 'post-pending',
            component: PostPending,
            meta: {
                auth: true
            }
        },
        {
            path: '/post/rejected',
            name: 'post-rejected',
            component: PostRejected,
            meta: {
                auth: true
            }
        },
        {
            path: '/post/revision',
            name: 'post-revision',
            component: PostRevision,
            meta: {
                auth: true
            }
        },
        {
            path: '/post/editing',
            name: 'post-editing',
            component: PostEditing,
            meta: {
                auth: true
            }
        },
        {
            path: '/post/create',
            name: 'post-create',
            component: CreatePost,
            meta: {
                auth: true
            }
        },
        {
            path: '/post/edit/:id',
            name: 'post-edit',
            component: EditPost,
            meta: {
                auth: true
            }
        },

          {
            path: '/video/record',
            name: 'video-record',
            component: CreateRecord,
            meta: {
                auth: true
            }
        },

        {
            path: '/video/published',
            name: 'video-published',
            component: VideoPublished,
            meta: {
                auth: true
            }
        },
        {
            path: '/video/draft',
            name: 'video-draft',
            component: VideoDraft,
            meta: {
                auth: true
            }
        },
        {
            path: '/video/pending',
            name: 'video-pending',
            component: VideoPending,
            meta: {
                auth: true
            }
        },
        {
            path: '/video/rejected',
            name: 'video-rejected',
            component: VideoRejected,
            meta: {
                auth: true
            }
        },
        {
            path: '/video/editing',
            name: 'video-editing',
            component: VideoEditing,
            meta: {
                auth: true
            }
        },
        {
            path: '/video/create',
            name: 'video-create',
            component: CreateVideo,
            meta: {
                auth: true
            }
        },
        {
            path: '/video/edit/:id',
            name: 'video-edit',
            component: EditVideo,
            meta: {
                auth: true
            }
        },

        {
            path: '/help',
            name: 'help',
            component: Help,
            meta: {
                auth: true
            }
        },
        {
            path: '/help/:id',
            name: 'help-show',
            component: HelpShow,
            meta: {
                auth: true
            }
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    }
})

const guard = function(to, from, next) {
    const token = Vue.$cookies.get('token')
    axios.get('/api/user', { headers: {"Authorization" : `Bearer ${token}`} }).then(response => {
        next();
    }).catch(error => {
        if(error.response) {
            if (error.response.status === 401) {
                Vue.$cookies.remove('token')
                next('/')
            }
        }
    })
};

 router.beforeEach((to, from, next) => {
     const loggedIn = Vue.$cookies.get('token')
     if (to.matched.some(record => record.meta.auth) && !loggedIn) next('/')
     else if (to.matched.some(record => !record.meta.auth) && to.matched.some(record => record.meta.force_guest)) next()
     else if (to.matched.some(record => !record.meta.auth) && loggedIn) next('/home')
     else if (to.matched.some(record => record.meta.auth) && loggedIn) guard(to, from, next);
     else next();
 });

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
    components: { App },
    router,
});
